import { render, staticRenderFns } from "./BookingBoardColumn.vue?vue&type=template&id=215e7fcc&scoped=true"
import script from "./BookingBoardColumn.vue?vue&type=script&lang=js"
export * from "./BookingBoardColumn.vue?vue&type=script&lang=js"
import style0 from "./BookingBoardColumn.vue?vue&type=style&index=0&id=215e7fcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215e7fcc",
  null
  
)

export default component.exports